<script>
    import MainContainer from "./MainContainer.svelte"

    let userId = ""
    let searching = false
	$: findUserAndNavigate(userId)

    async function findUserAndNavigate(userId) {
        if (userId && "Plwv6QXWYjPwjgMTV9IY6ZT6NFd2".length === userId.length) {
            searching = true
            try {
                window.location.href = "/#/User/" + userId
            }
            finally {
                searching = false
            }
        }
    }
</script>

<MainContainer>
    <h4>Find user:</h4>
    <div>
        <div class="input-field">
            <i class="material-icons prefix">search</i>
            <input id="search" type="text" class="validate" bind:value={userId}>
            <label for="search">Firebase id</label>
        </div>
        {#if userId && searching}
            <div class="progress">
                <div class="indeterminate"></div>
            </div>
        {/if}
        {#if userId && !searching}
            <p>Not found</p>
        {/if}
    </div>
</MainContainer>